var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonLoginCustomization = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#icon-login-customization_svg__clip0_403_1729)" },
            React.createElement("rect", { x: 8.402, y: 2, width: 28.565, height: 39.551, rx: 4.412, fill: fills.light }),
            React.createElement("rect", { x: 14.994, y: 19.578, width: 15.381, height: 4.395, rx: 1.099, fill: "#fff" }),
            React.createElement("rect", { x: 14.994, y: 26.17, width: 15.381, height: 4.395, rx: 1.099, fill: fills.dark }),
            React.createElement("circle", { cx: 22.684, cy: 14.085, r: 3.296, fill: fills.dark }),
            React.createElement("path", { d: "M26.015 41.838c0-.438.173-.857.482-1.166l11.496-11.496a1.648 1.648 0 012.33 0l2.512 2.511a1.648 1.648 0 010 2.33L31.339 45.515a1.648 1.648 0 01-1.166.482h-3.61a.55.55 0 01-.548-.549v-3.61z", fill: fills.dark }),
            React.createElement("path", { d: "M37.963 29.146a1.648 1.648 0 012.33 0l2.542 2.541a1.648 1.648 0 010 2.33l-2.417 2.417-4.872-4.872 2.417-2.416z", fill: fills.base })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "icon-login-customization_svg__clip0_403_1729" },
                React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })))));
}, {
    name: identiconComponentName,
})({});
